// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 读取系统设置列表（可按分组） GET /api/v1/dashboard/setting */
export async function DashboardSettingControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardSettingControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputConfigDtoArray>(
    "/api/v1/dashboard/setting",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 保存单个系统设置 PUT /api/v1/dashboard/setting */
export async function DashboardSettingControllerUpsertV1(
  body: MyApi.UpsertConfigDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputConfigDto>(
    "/api/v1/dashboard/setting",
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 读取单个系统设置 GET /api/v1/dashboard/setting/${param0} */
export async function DashboardSettingControllerGetByKeyV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardSettingControllerGetByKeyV1Params,
  options?: { [key: string]: any }
) {
  const { key: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputConfigDto>(
    `/api/v1/dashboard/setting/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 删除系统设置项 DELETE /api/v1/dashboard/setting/${param0} */
export async function DashboardSettingControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardSettingControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { key: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/dashboard/setting/${param0}`,
    {
      method: "DELETE",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 批量保存系统设置 PUT /api/v1/dashboard/setting/batch */
export async function DashboardSettingControllerBatchUpsertV1(
  body: MyApi.BatchUpsertConfigDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputConfigDtoArray>(
    "/api/v1/dashboard/setting/batch",
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
